import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import { ToastProvider } from "react-toast-notifications"
import "react-loading-skeleton/dist/skeleton.css"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import flatpickr from "flatpickr"
import { Japanese } from "flatpickr/dist/l10n/ja.js"
import "@fullcalendar/bootstrap/main.css";
import "react-datepicker/dist/react-datepicker.css"
import 'react-perfect-scrollbar/dist/css/styles.css';



flatpickr.localize(Japanese)

import store from "./store"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <Provider store={store}>
    <ToastProvider
      placement="bottom-right"
      autoDismiss
      autoDismissTimeout={2000}
    >
      <React.Fragment>
        <BrowserRouter>
          <App />
          <ToastContainer position="top-right" />
        </BrowserRouter>
      </React.Fragment>
    </ToastProvider>
  </Provider>
)

serviceWorker.unregister()
